export enum SubscriberIntegrationClient {
  Discord = 'discord',
  GitHub = 'github',
}
